







































import { Component, Inject, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IDelegatesMethods } from "./delegatesProvider.vue";

@Component
export default class DelegateInviteModal extends Mixins(HasValidation) {
  // Inject
  @Inject({ from: "delegatesMethods" })
  public readonly $delegatesMethods!: IDelegatesMethods;

  // Data
  public isProcessing = false;
  public form = {
    email: ""
  };

  // Methods
  public async sendInvite() {
    try {
      this.isProcessing = true;
      // Validate form
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      // Send invite
      await this.$delegatesMethods.sendInvite(this.form.email);
      // Confirmation toast
      this.$buefy.toast.open({
        message: this.$t("_sentence.delegates.invite_sent_to", {
          recipient: this.form.email
        }) as string
      });
      // Close modal
      this.$emit("close");
    } catch (error) {
      this.isProcessing = false;
      // Handle error
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
